import React from "react";
import { Link } from "react-router-dom";
import { LEGAL, LEGAL_ORDER } from "@/data/legal";
import { useSupportEmail } from "@/lib/config";

export default function Footer() {
  const year = new Date().getFullYear();
  const supportEmail = useSupportEmail();
  return (
    <footer className="mt-24 border-t border-[#1E3F33]/10 bg-[#F0EFEA]/40" data-testid="site-footer">
      <div className="container-x py-12 grid gap-8 md:grid-cols-3">
        <div>
          <div className="flex items-center gap-2 font-heading text-base font-semibold text-[#1E3F33]">
            <img src={`${process.env.PUBLIC_URL}/ssm-logo.webp`} alt="Screening Services Mobile logo" className="w-9 h-9 rounded-full object-contain bg-white ring-1 ring-[#1E3F33]/10" />
            <span className="text-[#B91C1C]">Screening Services Mobile</span>
          </div>
          <p className="text-sm text-[#5C6B64] mt-3 max-w-xs">A marketplace connecting customers with independent, certified specimen collectors near them.</p>
          <a href={`mailto:${supportEmail}`} className="text-sm text-[#CC5A3A] hover:underline mt-3 inline-block" data-testid="footer-contact">{supportEmail}</a>
        </div>
        <div>
          <h3 className="text-xs uppercase tracking-[0.2em] font-semibold text-[#1E3F33] mb-3">Explore</h3>
          <ul className="space-y-2 text-sm">
            <li><Link to="/search" className="text-[#5C6B64] hover:text-[#CC5A3A]" data-testid="footer-search">Find collectors</Link></li>
            <li><Link to="/register" className="text-[#5C6B64] hover:text-[#CC5A3A]" data-testid="footer-register">Become a collector</Link></li>
            <li><Link to="/login" className="text-[#5C6B64] hover:text-[#CC5A3A]" data-testid="footer-login">Sign in</Link></li>
          </ul>
        </div>
        <div>
          <h3 className="text-xs uppercase tracking-[0.2em] font-semibold text-[#1E3F33] mb-3">Legal</h3>
          <ul className="space-y-2 text-sm">
            {LEGAL_ORDER.map((k) => (
              <li key={k}><Link to={`/legal/${k}`} className="text-[#5C6B64] hover:text-[#CC5A3A]" data-testid={`footer-legal-${k}`}>{LEGAL[k].title}</Link></li>
            ))}
          </ul>
        </div>
      </div>
      <div className="border-t border-[#1E3F33]/10">
        <div className="container-x py-5 text-xs text-[#8A9A86] flex flex-wrap items-center justify-between gap-2">
          <span>© {year} Screening Services Mobile, LLC. All rights reserved.</span>
          <span>Not a medical provider or laboratory. Collectors are independent businesses.</span>
        </div>
      </div>
    </footer>
  );
}
